import { render, staticRenderFns } from "./TabCreateDispatch.vue?vue&type=template&id=5dc004df&"
import script from "./TabCreateDispatch.vue?vue&type=script&lang=ts&"
export * from "./TabCreateDispatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports